module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('box', {
    attrs: {
      "label": _vm.title
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('span', {
    staticClass: "textlink",
    class: {
      'disabled': false
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_vm._v("Zoom in")]), _vm._v("\n\t\t\t   \n\t\t\t"), _c('span', {
    staticClass: "textlink",
    class: {
      'disabled': (_vm.field_width <= 10)
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_vm._v("Zoom out")]), _vm._v("\n\t\t\t   \n\t\t\t"), _c('span', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.show_view_options = !_vm.show_view_options
      }
    }
  }, [_vm._v("Visning")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-container",
    class: {
      'has-sidebar': _vm.show_sidebar, 'grid-highlight-weeks': true
    }
  }, [(_vm.show_sidebar) ? _c('div', {
    staticClass: "timeline-sidebar",
    style: ({
      'width': _vm.sidebar_width + 'px'
    })
  }, [_c('div', {
    staticClass: "timeline-row months"
  }, [_c('div', {
    staticClass: "field month"
  }, [_vm._v("Måned")])]), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynames"
  }, [_c('div', {
    staticClass: "field dayname"
  }, [_vm._v("Ugedag")])]) : _vm._e(), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynumbers"
  }, [_c('div', {
    staticClass: "field daynumber"
  }, [_vm._v("Dag")])]) : _vm._e(), _vm._v(" "), (_vm.show_weeks) ? _c('div', {
    staticClass: "timeline-row weeks"
  }, [_c('div', {
    staticClass: "field week"
  }, [_vm._v("Uge")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entries), function(entry, entry_i) {
    return [_c('div', {
      staticClass: "timeline-row"
    }, [_c('div', {
      staticClass: "field entry",
      on: {
        "click": function($event) {
          return _vm.onEntrySidebarClick(entry)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(entry.title) + "\n\t\t\t\t\t\t")])])]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timeline-content-container",
    style: (_vm.timeline_content_container_css)
  }, [_c('div', {
    staticClass: "timeline-content",
    style: (_vm.timeline_content_css)
  }, [_c('div', {
    staticClass: "timeline-row months"
  }, [_vm._l((_vm.timeline_months), function(d, i) {
    return [_c('div', {
      staticClass: "field month",
      style: (_vm.month_field_css(d))
    }, [_vm._v(_vm._s(_vm.monthTitles[d.m]) + " " + _vm._s(d.y))])]
  })], 2), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynames"
  }, [_vm._l((_vm.timeline_dates), function(d, i) {
    return [_c('div', {
      staticClass: "field dayname",
      class: _vm.field_classes(d),
      style: (_vm.field_css)
    }, [_vm._v(_vm._s(_vm.dayInitials[d.dn]))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynumbers"
  }, [_vm._l((_vm.timeline_dates), function(d, i) {
    return [_c('div', {
      staticClass: "field daynumber",
      class: _vm.field_classes(d),
      style: (_vm.field_css)
    }, [_vm._v(_vm._s(d.d))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show_weeks) ? _c('div', {
    staticClass: "timeline-row weeks"
  }, [_vm._l((_vm.timeline_weeks), function(d, i) {
    return [_c('div', {
      staticClass: "field week",
      style: (_vm.month_field_css(d))
    }, [_vm._v("Uge " + _vm._s(d.w))])]
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.entries), function(entry, entry_i) {
    return [_c('div', {
      staticClass: "timeline-row entry"
    }, [_vm._l((_vm.timeline_dates), function(d, i) {
      return [_c('div', {
        staticClass: "field entry jeff",
        class: _vm.field_classes(d),
        style: (_vm.field_css)
      })]
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-entry",
      class: _vm.entry_marker_classes(entry),
      style: (_vm.entry_marker_css(entry)),
      on: {
        "click": function($event) {
          return _vm.onEntryClick(entry)
        }
      }
    }, [(entry.title) ? _c('div', {
      staticClass: "title",
      style: (_vm.entry_marker_title_css(entry))
    }, [_vm._v(_vm._s(entry.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "middle"
    }), _vm._v(" "), _c('div', {
      staticClass: "end end-r",
      style: (_vm.entry_marker_end_css('r', entry))
    }), _vm._v(" "), _c('div', {
      staticClass: "end end-l",
      style: (_vm.entry_marker_end_css('l', entry))
    }), _vm._v(" "), (entry.done_pct) ? _c('div', {
      staticClass: "done-bar",
      style: (_vm.entry_marker_donebar_css(entry))
    }) : _vm._e()])], 2)]
  })], 2)])]), _vm._v(" "), (_vm.show_view_options) ? [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis Datoer"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_dates),
      expression: "show_dates"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_dates) ? _vm._i(_vm.show_dates, null) > -1 : (_vm.show_dates)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_dates,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_dates = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_dates = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_dates = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis uger"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_weeks),
      expression: "show_weeks"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_weeks) ? _vm._i(_vm.show_weeks, null) > -1 : (_vm.show_weeks)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_weeks = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_weeks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_weeks = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": "Highlight uger"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grid_highlight_weeks),
      expression: "grid_highlight_weeks"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.grid_highlight_weeks) ? _vm._i(_vm.grid_highlight_weeks, null) > -1 : (_vm.grid_highlight_weeks)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grid_highlight_weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grid_highlight_weeks = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grid_highlight_weeks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grid_highlight_weeks = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis sidebar"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_sidebar),
      expression: "show_sidebar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_sidebar) ? _vm._i(_vm.show_sidebar, null) > -1 : (_vm.show_sidebar)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_sidebar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_sidebar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_sidebar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_sidebar = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Sidebar bredde"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sidebarWidth),
      expression: "sidebarWidth"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.sidebarWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sidebarWidth = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(_vm.globals.show_beta_content) ? _c('select', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "done_pct"
    }
  }, [_vm._v("BETA: Vis opgavers færdighed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "time_spent_pct"
    }
  }, [_vm._v("BETA: Vis opgavers tidsforbrug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "booked_pct"
    }
  }, [_vm._v("BETA: Vis opgavers tidsbooking")])]) : _vm._e()])]), _vm._v(" "), (_vm.globals.show_beta_content) ? [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Beta: Days back"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_back),
      expression: "days_back"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.days_back)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_back = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Days ahead"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_ahead),
      expression: "days_ahead"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.days_ahead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_ahead = $event.target.value
      }
    }
  })])], 1)])] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50024fd9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 602
// module chunks = 1